<template>
  <b-container class="mb-7" id="ueber" v-if="ueberUns.length > 0">
    <b-row>
      <b-col>
        <h2 class="text-right">Über uns</h2>
      </b-col>
    </b-row>
    <JukiAccordion :contentlist="contentList" right/>
  </b-container>
</template>

<script>
import JukiAccordion from "@/components/general/JukiAccordion.vue";
import { mapGetters } from "vuex";
import { sanitizeHtml } from "@/utils/richText";

export default {
  name: "Ueber",
  components: {
    JukiAccordion,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["ueberUns"]),
    contentList() {
      const result = {
        name: "ueberUns",
        content: [],
      };
      const contentArr = this.ueberUns;
      contentArr.forEach((element) => {
        const elem = {
          title: element.title,
          content: sanitizeHtml(element.contentHTML),
        };
        result.content.push(elem);
      });
      return result;
    },
  },
};
</script>
